import React from "react";

const setSimulationData = (data) => {
  const filteredData = {
    labels: data?.plotData.days,
    datasets: [],
  };

  if (data?.plotData.redPenetration !== null) {
    filteredData.datasets.push({
      label: "Red penetration",
      lineTension: 0,
      borderWidth: 1,
      borderColor: "#8b0000",
      backgroundColor: "#8b0000",
      data: data?.plotData.redPenetration,
      pointRadius: 0,
      stepped: true,
      hidden: true,
    });
  }
  if (data?.plotData.stockOnHand !== null) {
    filteredData.datasets.push({
      label: "Stock on hand",
      lineTension: 0,
      borderColor: "#000080",
      backgroundColor: "#000080",
      data: data?.plotData.stockOnHand,
      pointRadius: 0,
      stepped: true,
      hidden: false,
    });
  }

  if (data?.plotData.stockOnHandOnOrder !== null) {
    filteredData.datasets.push({
      label: "Stock OH + OO",
      lineTension: 0,
      borderWidth: 1,
      borderColor: "#000080",
      backgroundColor: "#000080",
      borderDash: [3, 3],
      data: data?.plotData.stockOnHandOnOrder,
      pointRadius: 0,
      stepped: true,
      hidden: false,
    });
  }
  if (data?.plotData.adu !== null) {
    filteredData.datasets.push({
      label: "ADU",
      lineTension: 0,
      borderWidth: 1,
      borderColor: "#404040",
      backgroundColor: "#404040",
      borderDash: [3, 3],
      data: data?.plotData.adu,
      pointRadius: 0,
      stepped: true,
      hidden: true,
    });
  }

  if (data?.plotData.netFlowPosition !== null) {
    filteredData.datasets.push({
      label: "Net flow position",
      lineTension: 0,
      borderWidth: 1,
      borderColor: "#b27300",
      backgroundColor: "#b27300",
      borderDash: [3, 3],
      data: data?.plotData.netFlowPosition,
      pointRadius: 0,
      stepped: true,
      hidden: true,
    });
  }

  if (data?.plotData.demand !== null) {
    filteredData.datasets.push({
      label: "Demand",
      type: "bar",
      barThickness: 10,
      lineTension: 0,
      borderWidth: 1,
      backgroundColor: "#ffa500",
      data: data?.plotData.demand,
      pointRadius: 0,
      stepped: true,
      hidden: true,
    });
  }

  if (data?.plotData.forecast !== null) {
    filteredData.datasets.push({
      label: "Forecast",
      data: data?.plotData.forecast,
      type: "bar",
      barThickness: 10,
      lineTension: 0,
      borderWidth: 1,
      backgroundColor: "#800080",
      pointRadius: 0,
      stepped: true,
      hidden: true,
    });
  }

  if (data?.plotData.consumption !== null) {
    filteredData.datasets.push({
      label: "Consumption",
      type: "bar",
      barThickness: 10,
      lineTension: 0,
      borderWidth: 1,
      backgroundColor: "#ee82ee",
      data: data?.plotData.consumption,
      pointRadius: 0,
      stepped: true,
      hidden: true,
    });
  }

  if (data?.plotData.backlog !== null) {
    filteredData.datasets.push({
      label: "Backlog",
      data: data?.plotData.backlog,
      lineTension: 0,
      borderColor: "#000000",
      backgroundColor: "#000000",
      pointRadius: 0,
      stepped: true,
      hidden: true,
    });
  }

  if (data?.plotData.orderedFromUpstream !== null) {
    filteredData.datasets.push({
      label: "Ordered from upstream",
      data: data?.plotData.orderedFromUpstream,
      type: "bar",
      barThickness: 10,
      lineTension: 0,
      borderWidth: 1,
      backgroundColor: "#556b2f",
      pointRadius: 0,
      stepped: true,
      hidden: true,
    });
  }

  if (data?.plotData.receipts !== null) {
    filteredData.datasets.push({
      label: "Receipts",
      data: data?.plotData.receipts,
      type: "bar",
      barThickness: 10,
      lineTension: 0,
      borderWidth: 1,
      backgroundColor: "#008000",
      pointRadius: 0,
      stepped: true,
      hidden: true,
    });
  }

  if (data?.plotData.redSafetyLevel !== null) {
    filteredData.datasets.push({
      label: "Red safety",
      lineTension: 0,
      backgroundColor: "#d7c0c0",
      pointRadius: 0,
      data: data?.plotData.redSafetyLevel,
      stepped: true,
      fill: true,
      hidden: true,
    });
  }

  if (data?.plotData.redLevel !== null) {
    filteredData.datasets.push({
      label: "Red base",
      backgroundColor: "#d7c0c0",
      pointRadius: 0,
      data: data?.plotData.redLevel,
      stepped: true,
      fill: true,
      hidden: false,
    });
    filteredData.datasets.push({
      label: "SUBTRACTION_RED_BASE_ZONE",
      backgroundColor: "rgba(0,0,0,0)",
      pointRadius: 0,
      data: data?.plotData.redLevel,
      stepped: true,
      fill: true,
      hidden: false,
    });
  }

  if (data?.plotData.yellowLevel !== null) {
    filteredData.datasets.push({
      label: "Yellow zone",
      backgroundColor: "#ffffc0",
      data: data?.plotData.yellowLevel,
      pointRadius: 0,
      stepped: true,
      fill: "-1",
    });
    filteredData.datasets.push({
      // zone for subtraction from yellow
      label: "SUBTRACTION_YELLOW_ZONE",
      backgroundColor: "rgba(0,0,0,0)",
      data: data?.plotData.yellowLevel,
      pointRadius: 0,
      stepped: true,
      fill: true,
    });
  }


  if (data?.plotData.greenLevel !== null) {
    filteredData.datasets.push({
      label: "Green zone",
      backgroundColor: "#c0dfc0",
      data: data?.plotData.greenLevel,
      pointRadius: 0,
      stepped: true,
      fill: "-1",
    });
  }
  return filteredData;
};

export default setSimulationData;
